<template>
  <div>
    <v-container fluid class="px-15">
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <template v-if="!isLoading">
        <div style="position: absolute;">
          <v-btn @click="$router.go(-1)" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>
        <v-row class="mt-6" justify="center" style="align-items: center;">
          <v-col>
            <h1 class="mb-3" style="font-family: 'montserrat-bold'; color: black; font-size: 32px; text-wrap: nowrap;">{{ "Detalle de factura" }}</h1>
          </v-col>
        </v-row>
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Proveedor:</p>
                <p class="value">{{ invoice?.paymentsRecipent[0].sName }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Status:</p>
                <p class="value">
                  <v-chip
                    v-if="invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="invoice.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Profit (%):</p>
                <p class="value profit-text">{{ dProfitPercentage ? formatMoney(dProfitPercentage) + " %" : '-' }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Profit ($):</p>
                <p class="value profit-text">{{ totalProfit ? "$" + formatMoney(totalProfit) + " USD" : '-' }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Factura:</p>
                <p class="value">{{ invoice.sInvoice }}</p>
              </div>
              <div class="info-block">
                <p class="label">Orden de pago:</p>
                <p class="value">{{ invoice.sId }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block">
                <p class="label">Fecha de compra:</p>
                <p class="value">{{ formatDate(invoice.dPurchaseDate) }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Fecha de vencimiento:</p>
                <p class="value">{{ formatDate(invoice.dDueDate) }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Tipo de cambio protegido:</p>
                <p class="value">{{ "$ " + formatMoney(invoice.dRateProtection) + " MXN" }}</p>
              </div>
               <div class="info-block">
                <p class="label">Dias de credito:</p>
                <p class="value">{{ invoice.iCreditPeriod }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block">
                <p class="label">Monto:</p>
                <p class="value amount-text" style="font-size: 30px;">{{ "$ " + formatMoney(invoice.dTotalAmount) + " " + invoice.paymentsRecipent[0].sAccountCurrency}}</p>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <template>
          <div style="display: flex; justify-content: space-between;" class="mt-9">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: black;">{{ "Conversiones Aplicadas" }}</div>
          </div>
          <v-data-table class="d-none d-sm-block" :items-per-page="10" hide-default-header :items="transactions" style="background-color: #f9fafd !important">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ "Id" }}</th>                                                                                                                                                                                  
                  <th class="header__title center">{{ "Fecha de creación" }}</th>
                  <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                                                                                          
                  <th class="header__title center">{{ "Available transaction" }}</th>
                  <th class="header__title center">{{ "Tipo de cambio" }}</th>
                  <th class="header__title center">{{ "Monto origen" }}</th>
                  <th class="header__title center">{{ "Monto destino" }}</th>
                  <th class="header__title center">{{ "Currency profit ($)" }}</th>
                  <th class="header__title center">{{ "Currency profit (%)" }}</th>
                  <th class="header__title right">{{ "Acciones" }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.created_at) }}</td>
                  <td class="table__item">
                    <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                      {{ "Forward" }}
                    </v-chip>
                    <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" class="ma-2" color="#2397C7" outlined style="background-color: #F0F8FE !important; border-width: 1.5px;">
                      {{ "Forex" }}
                    </v-chip>
                    <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                      {{ "Window spot" }}
                    </v-chip>
                    <v-chip v-else class="ma-2" color="orange" outlined style="background-color: #FDF8EB !important; border-width: 1.5px;">
                      {{ "Pay now" }}
                    </v-chip>
                  </td>
                  <td class="table__item">
                    <v-icon v-if="item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'" style="color: green;">mdi-check-circle</v-icon>
                    <v-icon v-else="item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'" style="color: red;">mdi-close-circle</v-icon>
                  </td>
                  <td class="table__item">{{  "$ " + formatMoney(item.dRate < 1 ? 1 / item.dRate : item.dRate) + " MXN" }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.appliedOriginAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.appliedDestAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
                  <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' USD' ) : "-" }}</td>
                  <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToTransaction(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ "Ver detalle" }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </template>
        <template>
          <div style="display: flex; justify-content: space-between;" class="mt-9">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: black;">{{ "Pagos Aplicados" }}</div>
          </div>
          <v-data-table class="d-none d-sm-block" :items-per-page="10" hide-default-header :items="payments" style="background-color: #f9fafd !important">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ "Id" }}</th>                                                                                                                                                                                  
                  <th class="header__title center">{{ "Fecha de creación" }}</th>
                  <th class="header__title center">{{ "Status" }}</th>
                  <th class="header__title center">{{ "Tipo de cambio" }}</th>
                  <th class="header__title center">{{ "Monto origen" }}</th>
                  <th class="header__title center">{{ "Monto destino" }}</th>
                  <th class="header__title right">{{ "Acciones" }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.created_at) }}</td>
                  <td class="table__item">
                    <v-chip :color="setStatusColor(item.statusLabel)" class="ma-2" outlined>
                      {{ item.statusLabel }}
                    </v-chip>
                  </td>
                  <td class="table__item">{{   item.paymentOriginCurrency != item.paymentDestCurrency ? ("$ " + formatMoney(item.dRate < 1 ? 1 / item.dRate : item.dRate) + " MXN") : "-" }}</td>
                  <td class="table__item">{{ item.paymentOriginCurrency != item.paymentDestCurrency ? ("$ " + formatMoney(item.appliedOriginAmount) + " " + (item.paymentOriginCurrency ? item.paymentOriginCurrency : "USD")) : "$ " + formatMoney(item.appliedDestAmount) + " " + (item.paymentDestCurrency ? item.paymentDestCurrency : "MXN")  }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.appliedDestAmount) + " " + (item.paymentDestCurrency ? item.paymentDestCurrency : "MXN") }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToPayment(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ "Ver detalle" }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </template>
      </template>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { mixs } from "@/mixins";

export default {
  name: "DashboardView",
  mixins: [mixs],
  data() {
    return {
      isLoading: false,
      invoice: null,
      totalProfit: 0,
      dProfitPercentage:  0,
      transactions: [],
      payments: [],
    };
  },
  created() {
    this.getInvoiceDetails();
  },
  methods: {
    getInvoiceDetails() {
      this.isLoading = true;
      this.totalProfit = 0;
      this.dProfitPercentage = 0;
      DB.get(`${URI}/api/v1/en/administrator/invoice/${this.$route.params.sInvoiceId}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.invoice = response.data.invoice;
          this.transactions = response.data.transactions;
          this.transactions.forEach((transaction) => {
            this.totalProfit += parseFloat(transaction.dCurrencyGain);
          });
          this.dProfitPercentage = (this.totalProfit / (this.invoice.dTotalAmount / this.invoice.dRateProtection)) * 100;
          this.payments = response.data.payments;
        })
        .catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    setStatusColor(status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "PENDING_TO_DEPOSIT"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
      else {
        return "gray";
      }
    },
    goToPayment(item) {
      this.$router.push({
        name: "PaymentDetail",
        params: { sPaymentId: item.sPaymentId }
      }).catch(() => {});
    },
    goToTransaction(item) {
      console.log(item.sTransactionId);
      this.$router.push({
        name: "ConversionDetail",
        params: { sTransactionId: item.sTransactionId }
      }).catch(() => {});
    }
  },
};
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F6F8FC;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
}

.profit-text {
  color: #0075B8;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: #0075B8;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos para el modal de cambio de estatus */
.status-modal {
  border-radius: 20px !important;
  background-color: #fff;
  overflow: hidden;
  padding: 0;
}

.warning-icon {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
  margin-bottom: -40px;
}

.status-modal-content {
  background-color: #000;
  color: white;
  text-align: center;
  padding: 20px 40px;
  margin: 50px 40px 20px 40px;
  border-radius: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
}

.status-selection-section {
  background-color: #f5f5f5;
  color: #333;
  padding: 5px 40px;
  margin: 0 40px 20px 40px;
  border-radius: 15px;
}

.payment-details-section {
  background-color: #f5f5f5;
  color: #333;
  padding: 25px 40px;
  margin: 0 40px 40px 40px;
  border-radius: 15px;
}

.warning-icon-outer {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #333;
  border: 3px solid #666;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 20px;
}

.warning-icon-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-exclamation {
  color: white;
  font-size: 36px;
  font-weight: bold;
  font-family: Arial, sans-serif;
}

.status-modal-title {
  font-family: 'montserrat-bold';
  font-size: 22px;
  margin-bottom: 0;
  line-height: 1.3;
  font-weight: 700;
  color: white;
}

.status-selection {
  margin-bottom: 20px;
  text-align: left;
}

.status-label {
  font-family: 'montserrat-medium';
  font-size: 16px;
  margin-bottom: 10px;
  display: block;
  color: #333;
}

.payment-details {
  margin-top: 20px;
  text-align: left;
}

.detail-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 8px 0;
}

.detail-label {
  color: #646464;
  font-family: 'montserrat-bold';
  font-weight: 600;
  text-align: left;
}

.detail-value {
  color: #737583;
  font-family: 'montserrat-bold';
  text-align: left;
}

.status-modal-actions {
  background-color: white;
  padding: 20px 30px 30px 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.cancel-btn {
  width: 120px;
  border-radius: 36px !important;
  border: 2px solid #000000 !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}

.accept-btn {
  width: 120px;
  border-radius: 36px !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}

/* Estilos para el modal de confirmación final */
.final-confirmation-modal {
  border-radius: 20px !important;
  background-color: #fff;
  overflow: hidden;
  padding: 0;
}

.final-confirmation-content {
  background-color: #000;
  color: white;
  text-align: center;
  padding: 50px 40px 40px 40px;
  margin: 50px 40px 40px 40px;
  border-radius: 15px;
}

.final-confirmation-title {
  font-family: 'montserrat-bold';
  font-size: 22px;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: 700;
}

.final-confirmation-description {
  font-family: 'montserrat-medium';
  font-size: 16px;
  line-height: 1.4;
  opacity: 0.95;
  margin: 0;
}

.final-confirmation-actions {
  background-color: white;
  padding: 20px 30px 30px 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}
</style>
